type AppointmentDescriptionFields = {
  description?: string | null;
  shortDescription?: string | null;
};

/**
 * Picks display text for appointment rows using tenant config.
 * Defaults to the long `description` field when source is unset.
 * Returns an empty string if the chosen field is empty — callers are
 * responsible for any further fallback logic.
 */
export const getAppointmentDescriptionForDisplay = (
  appointment: AppointmentDescriptionFields,
  source: string | null | undefined,
): string => {
  const description = (appointment.description ?? '').trim();
  const shortDescription = (appointment.shortDescription ?? '').trim();

  return source === 'short_description' ? shortDescription : description;
};
